import * as React from 'react';
import withEventTracker from './withEventTracker';

class TrackableElement extends React.Component {
  static defaultProps = {
    nonInteraction: true,
  };

  static resolveValue(valOrFunc, ...args) {
    if (typeof valOrFunc === 'function') return valOrFunc(...args);
    return valOrFunc;
  }

  constructor() {
    super();
    this.sendEvent = this.sendEvent.bind(this);
  }

  sendEvent(event, ...args) {
    const {
      eventCategory,
      eventAction,
      eventLabel,
      nonInteraction,
      eventTracker,
    } = this.props;

    const trackingAction = this.props.trackingAction || 'onClick';
    const valueArgs = [event, ...args];

    eventTracker.send(
      TrackableElement.resolveValue(eventCategory, ...valueArgs),
      TrackableElement.resolveValue(eventAction, ...valueArgs),
      TrackableElement.resolveValue(eventLabel, ...valueArgs),
      nonInteraction,
    );

    const eventHandler = this.props[trackingAction];
    if (typeof eventHandler === 'function') {
      eventHandler(event, ...args);
    }
  }

  render() {
    const {
      element,
      children,
      eventCategory,
      eventAction,
      eventLabel,
      nonInteraction,
      eventTracker,
      trackingAction = 'onClick',
      ...props
    } = this.props;

    return React.createElement(
      element,
      {
        ...props,
        [trackingAction]: this.sendEvent,
        // Add HTML attributes for documentation purposes
        'data-event-category': typeof eventCategory === 'string' ? eventCategory : '',
        'data-event-action': typeof eventAction === 'string' ? eventAction : '',
        'data-event-label': typeof eventLabel === 'string' ? eventLabel : '',
      },
      children,
    );
  }
}

export default withEventTracker(TrackableElement);
